import { v4 as uuidv4 } from 'uuid'

export const useLoadingOverlays = createGlobalState(
    () => {
        const loadingOverlays = shallowReactive([])

        const push = () => {
            loadingOverlays.push({
                id: uuidv4(),
            })
        }

        const pop = () => {
            loadingOverlays.pop()
        }

        // Forcibly clear all overlays, in case something goes wrong
        // We should prefer using pop to remove them one by one
        const clearAll = () => {
            loadingOverlays.splice(0, loadingOverlays.length)
        }

        return {
            loadingOverlays,
            push,
            pop,
            clearAll,
        }
    },
)
